/* =========================================================================
   SKWHEEL · LA WAITLIST
   1 attribution UTM · 2 validation + tags client · 3 redirection merci
   4 barre mobile · 5 page merci (prénom)
   Aucune dépendance. Tout est enveloppé en try/catch côté stockage :
   la page reste fonctionnelle en navigation privée.
   ========================================================================= */
(function () {
  'use strict';
  if (window.__skwLw) return;
  window.__skwLw = true;

  var root = document.querySelector('[data-lw]');
  var STORE_UTM = 'lw_utm';
  var STORE_NAME = 'lw_first_name';

  function store(kind) {
    try { return window[kind]; } catch (e) { return null; }
  }
  function get(kind, key) {
    var s = store(kind); if (!s) return null;
    try { return s.getItem(key); } catch (e) { return null; }
  }
  function set(kind, key, value) {
    var s = store(kind); if (!s) return;
    try { s.setItem(key, value); } catch (e) {}
  }

  /* Un tag Shopify : minuscules, sans virgule, 40 caractères max */
  function slug(value) {
    return String(value || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 40);
  }

  /* ---------- 5. PAGE MERCI --------------------------------------------- */
  var thanksName = document.querySelector('[data-lw-name]');
  if (thanksName) {
    var name = get('sessionStorage', STORE_NAME);
    if (name) thanksName.textContent = ', ' + name;
  }

  if (!root) return;
  var thanksUrl = root.getAttribute('data-thanks-url') || '/pages/la-waitlist-thanks';
  var isPreview = root.hasAttribute('data-lw-preview');

  /* ---------- 1. ATTRIBUTION UTM ---------------------------------------- */
  // Mémorisées à l'arrivée : le visiteur peut recharger ou naviguer avant de s'inscrire.
  var params = new URLSearchParams(location.search);
  var utm = {};
  ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content'].forEach(function (k) {
    if (params.get(k)) utm[k] = params.get(k);
  });
  if (Object.keys(utm).length) set('sessionStorage', STORE_UTM, JSON.stringify(utm));
  else {
    try { utm = JSON.parse(get('sessionStorage', STORE_UTM) || '{}') || {}; } catch (e) { utm = {}; }
  }

  /* ---------- 3. REDIRECTION MERCI -------------------------------------- */
  // Shopify revient sur la page avec ?customer_posted=true après un envoi réussi.
  // Le Liquid redirige déjà via form.posted_successfully? ; ceci est le filet de sécurité.
  if (!isPreview && params.get('customer_posted') === 'true') {
    location.replace(thanksUrl);
    return;
  }

  /* ---------- 2. VALIDATION + TAGS -------------------------------------- */
  var form = root.querySelector('[data-lw-form]');
  if (form) {
    var fields = {
      first: form.querySelector('[name="contact[first_name]"]'),
      email: form.querySelector('[name="contact[email]"]'),
      zip:   form.querySelector('[data-lw-zip]'),
      tags:  form.querySelector('[name="contact[tags]"]'),
      consent: form.querySelector('[data-lw-consent]')
    };
    var submit = form.querySelector('[type="submit"]');

    function flag(input, bad) {
      var box = input.closest('.lw-field, .lw-consent');
      if (box) box.classList.toggle('is-invalid', bad);
      input.setAttribute('aria-invalid', bad ? 'true' : 'false');
      return !bad;
    }
    function checks() {
      return {
        first: fields.first.value.trim().length > 0,
        email: /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(fields.email.value.trim()),
        zip: /^\d{5}$/.test(fields.zip.value.trim()),
        consent: fields.consent.checked
      };
    }

    // Le code postal n'accepte que des chiffres, 5 max
    fields.zip.addEventListener('input', function () {
      var clean = fields.zip.value.replace(/\D/g, '').slice(0, 5);
      if (clean !== fields.zip.value) fields.zip.value = clean;
    });
    // On efface l'erreur dès que le champ redevient valide, jamais avant le premier envoi
    form.addEventListener('input', function (e) {
      if (!form.classList.contains('was-submitted')) return;
      var ok = checks();
      Object.keys(ok).forEach(function (k) { if (e.target === fields[k]) flag(fields[k], !ok[k]); });
    });
    form.addEventListener('change', function (e) {
      if (form.classList.contains('was-submitted') && e.target === fields.consent) flag(fields.consent, !fields.consent.checked);
    });

    form.addEventListener('submit', function (e) {
      form.classList.add('was-submitted');
      var ok = checks();
      var valid = true;
      ['first', 'email', 'zip', 'consent'].forEach(function (k) { valid = flag(fields[k], !ok[k]) && valid; });
      if (!valid) {
        e.preventDefault();
        var firstBad = form.querySelector('[aria-invalid="true"]');
        if (firstBad) firstBad.focus();
        return;
      }

      var pref = form.querySelector('[name="lw-pref"]:checked');
      var tags = [
        root.getAttribute('data-tag') || 'la-waitlist',
        'la-zip-' + fields.zip.value.trim(),
        'la-pref-' + (pref ? pref.value : 'any')
      ];
      if (utm.utm_source) tags.push('utm-source-' + slug(utm.utm_source));
      if (utm.utm_campaign) tags.push('utm-campaign-' + slug(utm.utm_campaign));
      fields.tags.value = tags.join(', ');
      set('sessionStorage', STORE_NAME, fields.first.value.trim().slice(0, 40));

      submit.disabled = true;
      submit.textContent = submit.getAttribute('data-loading') || 'Sending…';

      if (isPreview) {
        // Maquette : pas de Shopify derrière, on montre la page merci.
        e.preventDefault();
        setTimeout(function () {
          document.dispatchEvent(new CustomEvent('lw:preview-success', { detail: { tags: fields.tags.value } }));
        }, 450);
      }
    });
  }

})();

/* SKWHEEL · fiche Pass : bloc accessoires replié (menu déroulant) */
(function () {
  if (window.__skwAcc) return;
  window.__skwAcc = true;
  document.querySelectorAll('[data-pp-acc]').forEach(function (box) {
    var head = box.querySelector('.lw-pp-acc__title');
    if (!head) return;
    head.setAttribute('role', 'button');
    head.setAttribute('tabindex', '0');
    head.setAttribute('aria-expanded', 'false');
    function toggle() {
      var open = box.classList.toggle('is-open');
      head.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    head.addEventListener('click', toggle);
    head.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); } });
  });
})();

/* SKWHEEL · vidéos et barre mobile, sur toute la page (les blocs sont des sections séparées) */
(function () {
  if (window.__skwLwPage) return;
  window.__skwLwPage = true;
  /* ---------- 4 bis. VIDÉOS --------------------------------------------- */
  // Lecture seulement à l'écran (batterie, data mobile) ; jamais en mouvement réduit.
  var videos = document.querySelectorAll('.lw-how__media video');
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  videos.forEach(function (v) {
    if (reduce) { v.removeAttribute('autoplay'); v.pause(); v.controls = true; }
  });
  if (!reduce && videos.length && 'IntersectionObserver' in window) {
    var vio = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { var p = en.target.play(); if (p && p.catch) p.catch(function () {}); }
        else en.target.pause();
      });
    }, { threshold: 0.25 });
    videos.forEach(function (v) { vio.observe(v); });
  }

  /* ---------- 4. BARRE MOBILE ------------------------------------------- */
  // Visible quand ni le formulaire ni le rappel final ne sont à l'écran.
  var sticky = document.querySelector('[data-lw-sticky]');
  var targets = document.querySelectorAll('[data-lw-hide-sticky]');
  if (sticky && targets.length && 'IntersectionObserver' in window) {
    var onScreen = new Set();
    var scrolled = false;
    function update() { sticky.classList.toggle('is-visible', scrolled && onScreen.size === 0); }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { en.isIntersecting ? onScreen.add(en.target) : onScreen.delete(en.target); });
      update();
    }, { threshold: 0.15 });
    targets.forEach(function (t) { io.observe(t); });
    window.addEventListener('scroll', function () {
      var s = window.scrollY > 200;
      if (s !== scrolled) { scrolled = s; update(); }
    }, { passive: true });
  }
})();
